<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import type { BadgeVariants } from '.'
import { cn } from '@ds/lib/utils'
import { badgeVariants } from '.'

const props = defineProps<{
  tone?: BadgeVariants['tone']
  variant?: BadgeVariants['variant']
  size?: BadgeVariants['size']
  /** Canonical `dot`: a 6px disc in the current text colour. */
  dot?: boolean
  class?: HTMLAttributes['class']
}>()
</script>

<template>
  <span :class="cn(badgeVariants({ tone, variant, size }), props.class)">
    <span
      v-if="dot"
      class="size-1.5 shrink-0 rounded-full bg-current"
    />
    <slot />
  </span>
</template>
